module.exports = __webpack_public_path__ + "img/ip-mgmt-logo-light.54712c3a.png";